import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SponsorAssetFile } from '../../../../infrastructure/services/assets.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'sx-image-asset-picker',
  templateUrl: './imageAssetPicker.component.html'
})
export class SxImageAssetPickerComponent {
  @Input('selected') selected: string;
  @Input('') assetImages = [];
  search;

  constructor(private activeModal: NgbActiveModal) {
  }

  select(asset: SponsorAssetFile) {
    this.selected = asset.codAsset;
  }

  confirmar() {
    this.activeModal.close(this.selected);
  }

  reset() {
    this.selected = null;
  }

  dismiss() {
      this.activeModal.dismiss();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/shared/imageAssetPicker.component.ts